@if (user$ | async; as user) {
    <!-- This check on translateService.translation$ prevents initial flickering when language is changed to the users
         language after the user is loaded -->
    @if (translateService.translation$ | async) {
        <div
            class="d-flex flex-column h-100"
            [ngClass]="{
                test: environment.includes('test'),
                dev: environment.includes('development'),
                local: environment.includes('local'),
            }">
            <div class="d-flex justify-content-between top-bar">
                <a routerLink="/">
                    <app-brunata-online-logo-component />
                </a>

                <div class="d-flex align-items-center h-100">
                    @if (searchEnabled$ | async) {
                        <button type="button" class="btn search-trigger" (click)="openSearch()">
                            <i class="bi bi-search" aria-hidden="true"></i>
                            <span>{{ 'titles_search' | translate: 'online' : 'systems' }}</span>
                        </button>
                    }
                    <div
                        ngbDropdown
                        class="h-100 user-menu"
                        [popperOptions]="noOffsetPopperOptions">
                        <div ngbDropdownAnchor class="h-100">
                            <div class="h-100 user-menu-area">
                                <div class="user-box">
                                    <p class="fw-bold text-uppercase">
                                        {{ user.fullName }}
                                    </p>
                                    <p class="gray">
                                        {{ user.username }}
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    class="btn"
                                    id="userMenu"
                                    (click)="$event.stopPropagation(); userMenu()?.toggle()">
                                    <svg
                                        width="13"
                                        height="13"
                                        fill="currentColor"
                                        viewBox="0 0 1048 1048">
                                        @switch (userMenu()?.isOpen()) {
                                            @case (true) {
                                                <path
                                                    d="M1024 707.84l-120.32 120.32-391.68-390.827-391.68 390.827-120.32-120.32 512-512z"></path>
                                            }
                                            @default {
                                                <path
                                                    d="M1024 316.16l-120.32-120.32-391.68 390.827-391.68-390.827-120.32 120.32 512 512z"></path>
                                            }
                                        }
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div ngbDropdownMenu aria-labelledby="userMenu">
                            <nav class="navbar">
                                <ul class="navbar-nav w-100">
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            routerLink="user-administration"
                                            (click)="userMenu()?.close()"
                                            >{{
                                                'titles_userAdministration'
                                                    | translate: 'online' : 'common'
                                            }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            routerLink="my-profile"
                                            (click)="userMenu()?.close()"
                                            >{{
                                                'titles_userProfile'
                                                    | translate: 'online' : 'common'
                                            }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            routerLink="api-tokens"
                                            (click)="userMenu()?.close()"
                                            >{{
                                                'properties_api_tokens'
                                                    | translate: 'online' : 'systems'
                                            }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            [href]="user.helpLink"
                                            target="_blank"
                                            (click)="userMenu()?.close()"
                                            >{{ 'titles_help' | translate: 'online' : 'common' }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            class="nav-link"
                                            routerLink="termination-of-contract"
                                            (click)="userMenu()?.close()"
                                            >{{
                                                'actions_cancelSystem'
                                                    | translate: 'online' : 'common'
                                            }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" routerLink="/log-out"
                                            >{{ 'actions_logout' | translate: 'online' : 'common' }}
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-grow-1 bottom-container">
                <ul
                    class="nav flex-column flex-nowrap overflow-y-auto overflow-x-hidden flex-shrink-0">
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="'system/'" routerLinkActive="active">
                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 1048 1048">
                                <path
                                    d="M488.934503,0 L651.912669,165.47208 L651.912669,496.416234 L977.884032,496.416234 L977.884032,1048 L0,1048 L0,275.776624 L325.956332,275.776624 L325.956332,165.47208 L488.934503,0 Z M869.226912,827.375648 L760.569789,827.375648 L760.569789,937.695456 L869.226912,937.695456 L869.226912,827.375648 Z M543.270576,827.375648 L434.613456,827.375648 L434.613456,937.695456 L543.270576,937.695456 L543.270576,827.375648 Z M217.299213,827.375648 L108.642091,827.375648 L108.642091,937.695456 L217.299213,937.695456 L217.299213,827.375648 Z M869.226912,606.736038 L760.569789,606.736038 L760.569789,717.055845 L869.226912,717.055845 L869.226912,606.736038 Z M543.270576,606.736038 L434.613456,606.736038 L434.613456,717.055845 L543.270576,717.055845 L543.270576,606.736038 Z M217.299213,606.736038 L108.642091,606.736038 L108.642091,717.055845 L217.299213,717.055845 L217.299213,606.736038 Z M543.270576,386.096427 L434.613456,386.096427 L434.613456,496.416234 L543.270576,496.416234 L543.270576,386.096427 Z M217.299213,386.096427 L108.642091,386.096427 L108.642091,496.416234 L217.299213,496.416234 L217.299213,386.096427 Z M543.270576,165.456817 L434.613456,165.456817 L434.613456,275.776624 L543.270576,275.776624 L543.270576,165.456817 Z"></path>
                            </svg>
                            <div class="link-text">
                                {{ 'titles_systems' | translate: 'online' : 'common' }}
                            </div>
                        </a>
                    </li>
                    @if (user.buildingServices.includes(buildingServices.ONLINE_REPORTING)) {
                        <li class="nav-item">
                            <a class="nav-link" routerLink="reporting" routerLinkActive="active">
                                <svg
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                    viewBox="0 0 1048 1048">
                                    <path
                                        d="M931.551756,0 C995.588034,0 1048,52.3786321 1048,116.433046 L1048,116.433046 L1048,931.549861 C1048,995.604276 995.588034,1048 931.551756,1048 L931.551756,1048 L116.448243,1048 C52.3948715,1048 0,995.604276 0,931.549861 L0,931.549861 L0,116.433046 C0,52.3786321 52.3948715,0 116.448243,0 L116.448243,0 L931.551756,0 Z M378.439698,553.10399 L291.103513,553.10399 L291.103513,669.554133 L174.672366,669.554133 L174.672366,756.874646 L291.103513,756.874646 L291.103513,873.341882 L378.439698,873.341882 L378.439698,756.874646 L494.887941,756.874646 L494.887941,669.554133 L378.439698,669.554133 L378.439698,553.10399 Z M873.327634,742.344018 L582.224122,742.344018 L582.224122,829.664531 L873.327634,829.664531 L873.327634,742.344018 Z M873.327634,596.781341 L582.224122,596.781341 L582.224122,684.101854 L873.327634,684.101854 L873.327634,596.781341 Z M809.872573,174.658118 L727.767332,256.747606 L645.679183,174.658118 L583.96777,236.370543 L666.055914,319.058349 L583.96777,401.147837 L645.679183,462.860257 L727.767332,380.770769 L809.872573,462.279031 L871.583986,400.549514 L789.495842,318.477123 L871.583986,236.370543 L809.872573,174.658118 Z M480.323361,274.799772 L189.219849,274.799772 L189.219849,362.120285 L480.323361,362.120285 L480.323361,274.799772 Z"></path>
                                </svg>
                                <div class="link-text">
                                    {{ 'titles_reporting' | translate: 'online' : 'common' }}
                                </div>
                            </a>
                        </li>
                    }
                    @if (
                        user.buildingServices.includes(buildingServices.BRUNATA_VISUAL_SERVICENAME)
                    ) {
                        <li class="nav-item">
                            <a class="nav-link" routerLink="visual" routerLinkActive="active">
                                <svg
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                    viewBox="0 0 1048 1048">
                                    <path
                                        d="M931.555558,0 C995.602553,0 1048,52.3965964 1048,116.442553 L1048,116.442553 L1048,931.540441 C1048,995.586398 995.602553,1048 931.555558,1048 L931.555558,1048 L116.444444,1048 C52.3974491,1048 0,995.586398 0,931.540441 L0,931.540441 L0,116.442553 C0,52.3965964 52.3974491,0 116.444444,0 L116.444444,0 L931.555558,0 Z M815.111111,582.212773 L698.666668,582.212773 L698.666668,815.097884 L815.111111,815.097884 L815.111111,582.212773 Z M582.222221,232.88511 L465.777779,232.88511 L465.777779,815.097884 L582.222221,815.097884 L582.222221,232.88511 Z M349.333332,407.540441 L232.888889,407.540441 L232.888889,815.097884 L349.333332,815.097884 L349.333332,407.540441 Z"></path>
                                </svg>
                                <div class="link-text">
                                    {{ 'titles_visual' | translate: 'online' : 'common' }}
                                </div>
                            </a>
                        </li>
                    }
                    @if (
                        user.buildingServices.includes(buildingServices.COMPASS) ||
                        user.buildingServices.includes(buildingServices.CONTROL_SYSTEM_WATER) ||
                        user.buildingServices.includes(buildingServices.CONTROL_SYSTEM_ENERGY)
                    ) {
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                routerLink="documentation"
                                routerLinkActive="active">
                                <div style="display: contents">
                                    <!-- This icon has other dimensions than the rest. Therefore we must compensate by adding a negative margin -->
                                    <svg
                                        height="33"
                                        width="33"
                                        fill="currentColor"
                                        viewBox="0 0 1048 1048"
                                        style="margin-right: -7px; margin-bottom: -7px">
                                        <path
                                            d="M382.590395,297.715039 L382.590395,63.990172 L616.315262,297.715039 M170.118968,510.186466 L510.079548,510.186466 L510.079548,425.204192 L170.118968,425.204192 M170.118968,680.166756 L510.079548,680.166756 L510.079548,595.184482 L170.118968,595.184482 M425.081532,0.245595307 L85.1209515,0.245595307 C38.3791268,0.245595307 0.548003556,38.486044 0.548003556,85.243612 L0.138678044,765.149029 C0.138678044,811.890854 37.954058,850.147046 84.6958827,850.147046 L595.061822,850.147046 C641.803647,850.147046 680.059839,811.890854 680.059839,765.149029 L680.059839,255.223902"></path>
                                    </svg>
                                </div>

                                <div class="link-text">
                                    {{ 'titles_documentation' | translate: 'online' : 'common' }}
                                </div>
                            </a>
                        </li>
                    }
                    @if (user.buildingServices.includes(buildingServices.MINENERGI2)) {
                        <li class="nav-item">
                            <a class="nav-link" [href]="" (click)="triggerMinEnergi2()">
                                <svg
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                    viewBox="0 0 1048 1048">
                                    <path
                                        d="M74.2493941,697.386827 L240.943578,741.25796 L183.460573,773.871425 C237.947749,848.178818 317.890547,905.180147 414.98846,930.747281 C567.561315,970.921681 722.941688,923.068637 825.351027,818.834685 L899.518391,891.660192 C771.587108,1020.9878 578.221115,1080.34818 388.370366,1030.35803 C263.161257,997.388856 160.745523,922.629311 92.4877575,825.488045 L29.5647905,861.185925 L74.2493941,697.386827 Z M524,199.111769 C668.08297,199.111769 790.66065,289.593698 836.102978,415.890049 L1048,415.92579 L1048,659.841563 L824.936622,659.846959 C772.645362,771.80302 657.562391,849.553829 524,849.553829 C390.437609,849.553829 275.354638,771.80302 223.063377,659.846959 L0,659.841563 L0,415.92579 L211.897024,415.890049 C257.33935,289.593698 379.91703,199.111769 524,199.111769 Z M433.574321,537.311599 L314.4,537.367876 C321.109888,637.702912 400.20086,718.526492 500.638498,729.490272 L500.638498,729.490272 L500.588419,603.49492 C467.807131,595.143582 442.005664,569.665594 433.574321,537.311599 L433.574321,537.311599 Z M614.425988,537.310394 C605.986916,569.695893 580.143928,595.192187 547.317544,603.518828 L547.317544,603.518828 L547.361502,729.490272 C647.79914,718.526492 726.890112,637.702912 733.6,537.367876 L733.6,537.367876 L614.425988,537.310394 Z M500.638498,317.54922 C406.429848,327.833046 331.002191,399.58018 316.47143,491.240903 L316.47143,491.240903 L433.596497,491.221845 C442.050534,458.909322 467.834017,433.469259 500.584981,425.124322 L500.584981,425.124322 L500.638498,317.54922 Z M547.361502,317.54922 L547.313373,425.098483 C580.113038,433.416746 605.941365,458.876536 614.403818,491.22305 L614.403818,491.22305 L731.52857,491.240903 C716.997809,399.58018 641.570152,327.833046 547.361502,317.54922 L547.361502,317.54922 Z M678.282305,17.641968 C803.491413,50.6111419 905.907151,125.370688 974.164915,222.511954 L1037.08788,186.814072 L992.40328,350.61317 L825.709097,306.742037 L883.192102,274.128577 C828.704926,199.821181 748.762129,142.81985 651.664216,117.252717 C499.091361,77.0783148 343.710983,124.931364 241.301648,229.165314 L167.134281,156.339805 C295.065569,27.0121968 488.431556,-32.348184 678.282305,17.641968 Z"></path>
                                </svg>
                                <div class="link-text">
                                    {{ 'titles_energyManagement' | translate: 'online' : 'common' }}
                                </div>
                            </a>
                        </li>
                        <app-minenergi2 />
                    }
                    @if (user.hasAcrossSystemsExport) {
                        <li class="nav-item">
                            <a class="nav-link" routerLink="export" routerLinkActive="active">
                                <svg
                                    width="33"
                                    height="33"
                                    fill="currentColor"
                                    viewBox="0 -960 960 960"
                                    style="
                                        margin-left: -6px;
                                        margin-right: -1px;
                                        margin-bottom: -1px;
                                    ">
                                    <path
                                        d="M480-480ZM202-65l-56-57 118-118h-90v-80h226v226h-80v-89L202-65Zm278-15v-80h240v-440H520v-200H240v400h-80v-400q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H480Z"></path>
                                </svg>
                                <div class="link-text">
                                    {{ 'titles_export' | translate: 'online' : 'common' }}
                                </div>
                            </a>
                        </li>
                    }
                    @if (installationProjectsEnabled$ | async) {
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                routerLink="installation-projects"
                                routerLinkActive="active">
                                <svg
                                    width="33"
                                    height="33"
                                    fill="currentColor"
                                    viewBox="0 -960 960 960"
                                    style="
                                        margin-left: -6px;
                                        margin-right: -1px;
                                        margin-bottom: -1px;
                                    ">
                                    <path
                                        d="M756-120 537-339l84-84 219 219-84 84Zm-552 0-84-84 276-276-68-68-28 28-51-51v82l-28 28-121-121 28-28h82l-50-50 142-142q20-20 43-29t47-9q24 0 47 9t43 29l-92 92 50 50-28 28 68 68 90-90q-4-11-6.5-23t-2.5-24q0-59 40.5-99.5T701-841q15 0 28.5 3t27.5 9l-99 99 72 72 99-99q7 14 9.5 27.5T841-701q0 59-40.5 99.5T701-561q-12 0-24-2t-23-7L204-120Z"></path>
                                </svg>
                                <div class="link-text">
                                    {{
                                        'titles_installationProjects'
                                            | translate: 'online' : 'common'
                                    }}
                                </div>
                            </a>
                        </li>
                    }
                </ul>

                <div class="d-flex flex-grow-1 right-content flex-column">
                    @if ((skipBreadcrumb$ | async) === false) {
                        <app-breadcrumb />
                        <div class="mt-3"></div>
                    }
                    <router-outlet />
                </div>
            </div>
        </div>
    }
}
